import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { Tab } from "react-bootstrap";
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import { useLocation, useNavigate } from "react-router-dom";
import Select, { StylesConfig } from "react-select";
import { toast } from "react-toastify";
import '../../../Airoom.css';
import Ribbon from "../../../core/common/ribbon/ribbon";
import { useGetModulesQuery, useGetRolesPermissiosLookupQuery, useGetSubModulesQuery, useLazyGetScreenPermissionsByRoleQuery, useUpdateRoleWisePermissionsMutation } from "../../../services/EndPointsApis";
import { svgIcons } from "../../../style/fonts/SvgIcons";
import PermissionsComponent from "./PermissionsComponent";
import { useDispatch, useSelector } from "react-redux";
import { setPermissionsState, setUser } from "../../../Features/authslice";

//New Code 
type PermissionType = 'create' | 'edit' | 'view' | 'assign' | 'delete' | 'allowAll';

interface PermissionItem {
  id: number;
  name: string;
  haveaccess: boolean;
}

interface Permission {
  screenName: string;
  create: boolean;
  edit: boolean;
  view: boolean;
  assign: boolean;
  delete: boolean;
  allowAll: boolean;
  moduleId: number
  fk_SubModuleId:number
  permissionList:PermissionItem[]
}

const Permissions = () => {
  const [rolesId, setRolesId] = useState(1)
  const [moduleId, setModuleId] = useState(10)
  const [role, setRole] = useState({
    value: 1,
    label: 'Sales Admin'
  })

  const [trigger, { data: allscreensPermissions }] = useLazyGetScreenPermissionsByRoleQuery();
  const dispatch = useDispatch();
  const permissionsConsole = useSelector((state: any) => state.auth.permissions);

  const [isApiHit, setIsApiHit] = useState(false)
  // const { data: allscreensPermissions } = useGetScreenPermissionsByRoleQuery({ roleId: rolesId });
  // const { data: getSubModuleData, refetch: getSubModuleDataRefetch } = useGetSubModulesQuery({ moduleId: moduleId });
  const { data: getModulesData, refetch: refetchModule } = useGetModulesQuery('');
  const [updatePermissions, { data: updatePermissionData, isError, error, isSuccess, isLoading }] = useUpdateRoleWisePermissionsMutation();//create permissions Api
  const { data: rolesLookups, refetch: refetchLookups } = useGetRolesPermissiosLookupQuery({
    RoleId: rolesId,
  });

  useEffect(() => {
    if (moduleId) {
      trigger({ RoleId: 1, ModuleId: moduleId });
    }

  }, [])

  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [allPermissions, setAllPermissions] = useState<Permission[]>([]);


  useEffect(() => {
    if (rolesId && allscreensPermissions?.result && allscreensPermissions.result.length > 0) {
      const mappedPermissions = allscreensPermissions.result.map((permission: any) => ({
        id: permission.id,
        fk_SubModuleId: permission.fk_SubModuleId || 0,
        fk_RoleID: permission.fk_RoleID || 0,
        screenName: permission.screenName,
        create: permission.create || false,
        edit: permission.edit || false,
        view: permission.view || false,
        assign: permission.assign || false,
        delete: permission.delete || false,
        allowAll: permission.allowAll || false,
        moduleId: permission.moduleId || 0,
        permissionList: permission.permissionList || null
      }));
      formik.setValues({ ...allscreensPermissions });
      setPermissions(mappedPermissions);
    } else if (allscreensPermissions?.result && allscreensPermissions.result.length > 0) {
      const mappedPermissions = allscreensPermissions.result.map((permission: any) => ({
        screenName: permission.screenName,
        create: permission.create || false,
        edit: permission.edit || false,
        view: permission.view || false,
        assign: permission.assign || false,
        delete: permission.delete || false,
        allowAll: permission.allowAll || false,
        moduleId: permission.moduleId || 0

      }));
      setPermissions(mappedPermissions);
      setIsApiHit(true)
    } else {
      // Clear permissions if no result is returned from either API
      setPermissions([]);
    }
  }, [allscreensPermissions, allscreensPermissions?.result]);



  const initialValues = {
    permissionsList: [
      {
        id: 0,
        view: false,
        edit: false,
        delete: false,
        create: false,
        assign: false,
        name: '',
        screenName: '',
        firstName: '',
        fk_SubModuleId: 0,
        fk_RoleID: 0,
        fk_UserID: 0
      }
    ],
    permissionList: [
      {
        id: 0,
        name: "",
        haveaccess: false
      }
    ]
  };



  const formik = useFormik({
    initialValues,
    // validationSchema:loginSchema,
    onSubmit: (values) => {
      // updatePermissions(values)
      const payload = values.permissionsList.map(({ ...rest }) => rest);
      // const payload = values.permissionsList.map(permission => ({
      //   id: permission.id,  // Include the id in the payload
      //   fk_SubModuleId: permission.fk_SubModuleId,
      //   fk_RoleID: permission.fk_RoleID,
      //   screenName: permission.screenName,
      //   create: permission.create,
      //   edit: permission.edit,
      //   view: permission.view,
      //   assign: permission.assign,
      //   delete: permission.delete,
      //   // allowAll: permission.allowAll,
      // }));

      updatePermissions(payload);
    }
  });




  const handleRoleChange = (selectedOption: any) => {
    const roleId = selectedOption.value;
    setRolesId(roleId);
    setRole(selectedOption)
    formik.setFieldValue('fk_RoleID', selectedOption.value)
    formik.setFieldValue('name', selectedOption.label)
    trigger({ RoleId: roleId, ModuleId: moduleId });
  };

  const customStyles: StylesConfig = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "rgba(177, 31, 40, 1)",
      },
    }),
  };

  const handleTableHeadChange = (moduleId: any, type: PermissionType, isChecked: boolean) => {
    const updatedPermissions = permissions.map(permission =>
      permission.moduleId === moduleId ?
        ({
          ...permission,
          [type]: isChecked,
          view: type === 'view'
            ? isChecked
            : isChecked || permission.create || permission.edit || permission.assign || permission.delete ?
              isChecked
              : !isChecked || !permission.create || !permission.edit || !permission.assign || !permission.delete,
        })
        : permission
    );
    setPermissions(updatedPermissions);
    formik.setFieldValue('permissionsList', updatedPermissions);
  };
  const handleRowChange = (index: number, isChecked: boolean) => {
    const updatedPermissions = permissions.map((permission, i) =>
      i === index
        ? {
          ...permission,
          create: isChecked,
          edit: isChecked,
          view: isChecked,
          assign: isChecked,
          delete: isChecked,
          allowAll: isChecked
        }
        : permission
    );
    setPermissions(updatedPermissions);
    formik.setFieldValue('permissionsList', updatedPermissions);
  };


  const handleMasterChange = (isChecked: boolean) => {
    const updatedPermissions = permissions.map(permission => ({
      ...permission,
      screenName: permission.screenName,
      create: isChecked,
      edit: isChecked,
      view: isChecked,
      assign: isChecked,
      delete: isChecked,
      allowAll: isChecked
    }));
    setAllPermissions(updatedPermissions)
    setPermissions(updatedPermissions);
    formik.setFieldValue('permissionsList', updatedPermissions);
  };
  const handleAllowAllChange = (moduleId: any, isChecked: boolean) => {
    const updatedPermissions = permissions.map(permission =>
      permission.moduleId === moduleId
        ? { ...permission, allowAll: isChecked, create: isChecked, edit: isChecked, view: isChecked, assign: isChecked, delete: isChecked }
        : permission
    );

    setPermissions(updatedPermissions);
    formik.setFieldValue('permissionsList', updatedPermissions);
  };


  // const handleIndividualChange = (index: number, type: PermissionType, isChecked: boolean) => {
  //   const updatedPermissions = [...permissions];
  //   updatedPermissions[index][type] = isChecked;
  //   if (type !== 'view' && isChecked) {
  //     updatedPermissions[index].view = true;
  //   } if (type === 'view') {
  //     updatedPermissions[index].view = isChecked;
  //   }
  //   setPermissions(updatedPermissions);
  //   formik.setFieldValue('permissionsList', updatedPermissions);
  // };
  
  const handleIndividualChange = (
    index: number,
    type: PermissionType | number,
    isChecked: boolean,
    isNested: boolean = false
  ) => {
    setPermissions((prevPermissions) => {
      const updatedPermissions = prevPermissions.map((permission, parentIndex) => {
        if (parentIndex === index) {
          if (isNested) {
            // Handling nested permissionList updates
            const childIndex = type as number;
            return {
              ...permission,
              permissionList: permission?.permissionList?.map((item, idx) =>
                idx === childIndex ? { ...item, haveaccess: isChecked } : item
              ),
            };
          } else {
            // Handling top-level permission updates
            return {
              ...permission,
              [type as PermissionType]: isChecked,
              view: type !== "view" && isChecked ? true : permission.view,
            };
          }
        }
        return permission;
      });
  
      formik.setFieldValue("permissionsList", updatedPermissions);
      return updatedPermissions; 
    });
  };
  
 
  const handleRefresh = () => {
    refetchLookups()
    refetchModule()
  }

  //New Code

  const items = [
    {
      label: 'Save',
      tooltipLabel: "Save",
      icon: svgIcons.SaveIcon,
      itemClass: "modal custom-modal fade",
      onClick: () => formik.handleSubmit()
      // onClick: () => setShowModal(true),
    },
    {
      label: "Allow All Modules",
      tooltipLabel: "Save",
      checkbox: true,
      checked: permissions.length > 0 ? permissions.every(permission =>
        permission.create &&
        permission.edit &&
        permission.view &&
        permission.assign &&
        permission.delete &&
        permission.allowAll
      ) : false,
      onChange: () => handleMasterChange(!(permissions.length > 0 ? permissions.every(permission =>
        permission.create &&
        permission.edit &&
        permission.view &&
        permission.assign &&
        permission.delete &&
        permission.allowAll
      ) : false))
    },
    { label: 'Refresh', tooltipLabel: "Refresh ", icon: <i className="ti ti-refresh-dot" aria-hidden="true"></i>, onClick: () => handleRefresh() },

  ];

  useEffect(() => {
    if (isSuccess) {
      toast.success(updatePermissionData?.message);
      // dispatch(
      //   setPermissionsState(updatePermissionData?.result)
      // );
      // trigger({ RoleId: rolesId7, ModuleId: moduleId });
    }
  }, [isSuccess, updatePermissionData]);

  useEffect(() => {
    if (isError && error) {
      let errorMessage: string = 'Something went wrong';

      if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
        errorMessage = (error.data as { message: string }).message;
      }
      toast.error(errorMessage);
    }
  },
    [isError, error]);

  return (
    <>
      <div>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                <Ribbon
                  items={items}
                  buttonClass="ribbon-btn add-popup"
                  toggleData="modal"
                />
                {/* /Page Header */}
                <div className="card main-card">
                  <div className="card-body">
                    {/* Search */}
                    <div className="mb-0">
                      <div className="row justify-content-between align-items-center">
                        <div className="col-md-12 ">
                          <div className="d-flex gap-2 flex-column flex-md-row align-items-center justify-content-between">
                            <h4 className="page-title color-red">
                              Permissions
                              {/* <span><i className="ti ti-chevron-right ms-2"></i></span> */}
                            </h4>
                            <div className="d-md-flex gap-3 align-items-center">
                              <h5 className="text-center">Select Role :</h5>
                              <div>
                                <Select
                                  styles={customStyles}
                                  className="select select-width"
                                  options={[
                                    ...(rolesLookups?.result?.roles?.map((option: any) => ({
                                      label: option?.name,
                                      value: option?.id
                                    })) || [])
                                  ]}
                                  value={
                                    rolesId
                                      ? {
                                        value: role.value,
                                        label: role.label,
                                      }
                                      : null
                                  }
                                  // {...formik.getFieldProps("role")}
                                  placeholder='Select Role'
                                  onChange={handleRoleChange}
                                />
                              </div>
                            </div>

                          </div>
                        </div>
                        <div>
                          <Tab.Container id="left-tabs-example" defaultActiveKey="Lead Prospect">
                            <Row>
                              <div className='card'>
                                <div className='card-body'>
                                  <Col sm={12}>
                                    <Nav className="flex">

                                      {getModulesData?.result?.map((data: any, index: any) => {
                                        return (
                                          <Nav.Item key={data?.id || index}>
                                            <Nav.Link className="nav-tabs" eventKey={data?.name} onClick={() => setModuleId(data?.id)}>
                                              {data?.name}
                                            </Nav.Link>
                                          </Nav.Item>
                                        )
                                      })}

                                    </Nav>
                                  </Col>
                                </div>
                              </div>
                              <Col sm={12}>
                                {getModulesData?.result?.map((data: any, index: any) => {
                                  return (
                                    <Tab.Content key={`content-${data?.id}`}>
                                      <Tab.Pane eventKey={data?.name}>
                                        <PermissionsComponent
                                          permissions={permissions}
                                          onTableHeadChange={handleTableHeadChange}
                                          onRowChange={handleRowChange}
                                          onIndividualChange={handleIndividualChange}
                                          onMasterChange={handleMasterChange}
                                          handleAllowAllChange={handleAllowAllChange}
                                          moduleId={moduleId}
                                        />
                                      </Tab.Pane>
                                    </Tab.Content>
                                  )
                                })}
                              </Col>
                            </Row>
                          </Tab.Container>

                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Permissions;
